export default "__VITE_ASSET__PgQydqfC__"